import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../api/axios';
import { BASE_URL } from '../constants/apiConstants';

interface initialState {
  sites: any[],
  meals: any[],
  menuReportDetails: any[],
  kitenReportDetails: any[],
  kitenReportSAPDetails: any[],
  loading: boolean,
  error: any,
}

const initialState: initialState = {
  sites: [],
  meals: [],
  menuReportDetails: [],
  kitenReportDetails: [],
  kitenReportSAPDetails: [],
  loading: false,
  error: null
};

export const fetchSites = createAsyncThunk(
  'varianceReport/fetchSites',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/Site/GetSitesByUserId`, payload);
    return response?.data?.data?.sites;
  }
);

export const fetchMeals = createAsyncThunk(
  'varianceReport/fetchmeals',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/InitiateMenuPlan/GetDayPart`, payload);
    return response?.data?.data?.daypartlist;
  }
);

// Fetch Menu Report Details
export const fetchGetMenuReportDetails = createAsyncThunk(
  'varianceReport/fetchMenuReportDetails',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/Report/GetMenuReportDetails`, payload);
    return response?.data?.data?.menulist;    
  }
);
// Fetch kitcken Report Details
export const fetchKitchenReportDetails = createAsyncThunk(
  'varianceReport/fetchKitchenReportDetails',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/Report/GetKitchenIndentReport`, payload);
    return response?.data?.data?.kitchenindentlist;    
  }
);
// Fetch kitcken SapReport Details
export const fetchKitchenSAPReportDetails = createAsyncThunk(
  'varianceReport/fetchKitchenSAPReportDetails',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/Report/GetKitchenIndentSAPReport`, payload);
    return response?.data?.data?.kitchenindentlist;    
  }
);

const varianceReportSlice = createSlice({
  name: 'varianceReport',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSites.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSites.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.sites = payload;
      })
      .addCase(fetchSites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    // daypart 
    builder
      .addCase(fetchMeals.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMeals.fulfilled, (state, action) => {
        state.loading = false;
        state.meals = action.payload;
      })
      .addCase(fetchMeals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    // menu report details
    builder
      .addCase(fetchGetMenuReportDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGetMenuReportDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.menuReportDetails = action.payload;
      })
      .addCase(fetchGetMenuReportDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    // kitchen report details
    builder
      .addCase(fetchKitchenReportDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchKitchenReportDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.kitenReportDetails = action.payload;
      })
      .addCase(fetchKitchenReportDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchKitchenSAPReportDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchKitchenSAPReportDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.kitenReportSAPDetails = action.payload;
      })
      .addCase(fetchKitchenSAPReportDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export default varianceReportSlice.reducer;
